import { Trigger } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useContactUpdateInquiry } from "../../contactUpdateInquiries/ContactUpdateInquiryProvider";
import { ContactPersonalInformationDrawer } from "../../contactUpdateInquiries/sections/ContactPersonalInformationDrawer";
import {
	ViewPageSection,
	ViewPageSectionBody,
	ViewPageSectionHeader,
	ViewPageSectionListItem,
} from "../../shared/view";

const StyledViewPageSection = styled(ViewPageSection)`
	grid-area: personal;
`;

const Label = styled.span`
	font-weight: ${({ theme }) => theme.fonts.weights.bold};
`;

const RowWrapper = styled.div`
	display: grid;
	grid-template-columns: max-content 1fr;
	flex: 1;
	gap: ${({ theme }) => theme.spacing(3)};
`;

const Row: FC<{ label: string; value: string }> = ({ label, value }) => {
	return (
		<>
			<Label>{label}:</Label>
			<span>{value}</span>
		</>
	);
};

export const ContactViewPersonalInformationSection: FC = () => {
	const { t } = useTranslation();
	const { contactBaseData, setContactBaseData } = useContactUpdateInquiry();

	return (
		<StyledViewPageSection>
			<ViewPageSectionHeader>{t("Personal information")}</ViewPageSectionHeader>
			<ViewPageSectionBody>
				{contactBaseData && (
					<Trigger
						render={(props) => (
							<ContactPersonalInformationDrawer
								open={props.open}
								onClose={props.handleClose}
								title={t("Edit personal information")}
								initialValues={contactBaseData}
								onClosed={() => void 0}
								onSubmit={async (values) => {
									setContactBaseData(values);

									return true;
								}}
							/>
						)}
					>
						{(props) => (
							<ViewPageSectionListItem {...props}>
								<RowWrapper>
									<Row label={t("First name")} value={contactBaseData?.firstName} />
									<Row label={t("Last name")} value={contactBaseData?.lastName} />
								</RowWrapper>
							</ViewPageSectionListItem>
						)}
					</Trigger>
				)}
			</ViewPageSectionBody>
		</StyledViewPageSection>
	);
};
